// extracted by mini-css-extract-plugin
export default {"container":"TableAllWastesCell_container__XLQed"};